import { render, staticRenderFns } from "./DesignerDetails.vue?vue&type=template&id=155c1299"
import script from "./DesignerDetails.vue?vue&type=script&lang=ts"
export * from "./DesignerDetails.vue?vue&type=script&lang=ts"
import style0 from "./DesignerDetails.vue?vue&type=style&index=0&id=155c1299&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports